import { AppState } from "react-native";

export function waitForUserToReturnToApp() {
  return new Promise<void>((resolve) => {
    const listener = AppState.addEventListener("change", (state) => {
      console.log("AppState listener running. State:", state);

      if (state === "active") {
        listener.remove();
        resolve();
      }
    });
  });
}
